import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import * as Yup from 'yup';
import commissionType from 'data/affiliate_commission_types';
import useCurrencies from 'components/Common/Currencies/Hooks/useCurrencies';
import useAffiliates from 'components/Common/Affiliates/Hooks/useAffiliates';

import { SwitchField } from 'ui/FormElement';

import {
  Formik,
  Form as FormikForm,
  FieldArray,

} from 'formik';
import deleteIcon from 'images/icons/invite/delete.svg';
import Modal from '../../../ui/Modal';

import { useContext } from '../Context';

import {
  TextField,
  TextFieldWithAddon,
  SelectFieldV2,
  DateField,
  CancelPopupButton,
  SubmitButton,
} from '../../../../ui/FormElement';

import statuses from '../../../../data/policy_statuses';

export default function EditModal({ show, onHide }) {
  const { dispatch, actions, state } = useContext();

  const { currencies } = useCurrencies();
  const { affiliates } = useAffiliates();

  const FormSchema = Yup.object().shape({
    total_employees: Yup.number()
      .required('required')
      .min(1, 'Total Employees must be greater than 0'),
    status: Yup.string().required('required'),
    number: Yup.string().required('required'),
    invoicing_day: Yup.string().required('required'),
    currency_id: Yup.string().required('required'),
    payment_terms: Yup.number()
      .required('required')
      .min(1, 'Payment Terms must be greater than 0'),
    renewal_notification_date: Yup.string()
      .when('renewal_notification', {
        is: true,
        then: (schema) => schema.required('required'),
      }),
    cancelled_at: Yup.string()
      .when('status', {
        is: 'blocked',
        then: (schema) => schema.required('required'),
      }),
    affiliates: Yup.array().of(
      Yup.object().shape({
        affiliate: Yup.string().required('required'),
        commission_type: Yup.string().required('required'),
        commission: Yup.string().required('required'),
      }),
    ),

  });

  const [loader, setLoader] = useState(false);

  const formData = {
    number: state.policy.attributes.number,
    total_employees: state.policy.attributes.total_employees,
    status: state.policy.attributes.status,
    payment_terms: state.policy.attributes.payment_terms,
    currency_id: state.policy.attributes.currency_id,
    renewal_notification: state.policy.attributes.renewal_notification,
    renewal_notification_date: state.policy.attributes.renewal_notification_date,
    affiliates: state.policy.attributes.affiliates,
    cancelled_at: state.policy.attributes.cancelled_date,
    invoicing_day: state.policy.attributes.invoicing_day,
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);
    actions.updatePolicy(
      dispatch,
      state.enterpriseId,
      state.policy.id,
      values,
      () => {
        setLoader(false);
        toastr.info('Policy updated.');
        onHide();
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      },
    );
  };

  return (
    <Modal show={show} onHide={onHide} header="Edit Policy">

      <Formik
        enableReinitialize
        validationSchema={FormSchema}
        initialValues={formData}
        onSubmit={onSubmit}
      >
        {({ values, touched, setFieldValue }) => {
          console.log(touched);
          useEffect(() => {
            if (values.status === 'blocked' && touched.status) {
              setFieldValue('renewal_notification', false);
            }
          }, [values.status, touched.status]);

          return (
            <FormikForm className="needs-validation" noValidate="">

              <div>
                <TextField
                  name="number"
                  label={(
                    <>
                      <span>Policy Number</span>
                      <abbr title="required">*</abbr>
                    </>
                )}
                />

                <TextField
                  name="total_employees"
                  type="number"
                  label={(
                    <>
                      <span>Total Employees</span>
                      <abbr title="required">*</abbr>
                    </>
                )}
                />

                <SelectFieldV2
                  name="status"
                  placeholder="Choose Status"
                  isMulti={false}
                  options={statuses}
                  label={(
                    <>
                      <span>Status</span>
                      <abbr title="required">*</abbr>
                    </>
                )}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                  }}
                  menuPortalTarget={document.body}
                />

                <DateField
                  name="cancelled_at"
                  disabled={values.status !== 'blocked' || state.policy.attributes.status === 'blocked'}
                  label={(
                    <span>Cancellation Date</span>
                    )}
                />

                <TextField
                  name="payment_terms"
                  label={(
                    <>
                      <span>Payment Terms</span>
                      <abbr title="required">*</abbr>
                    </>
                )}
                  hint="Payment Terms will be applied on any future invoice."
                />

                <TextField
                  name="invoicing_day"
                  label={(
                    <>
                      <span>Invoicing Day</span>
                      <abbr title="required">*</abbr>
                    </>
                )}
                  hint="Invoicing Day will be applied on any future invoice."
                />

                <SelectFieldV2
                  name="currency_id"
                  placeholder={currencies === null ? 'Wait ...' : 'Currency'}
                  isMulti={false}
                  options={currencies && currencies.map((item) => ({
                    label: item.attributes.title,
                    value: item.attributes.id,
                  }))}
                  label={(
                    <>
                      <span>Currency</span>
                      <abbr title="required">*</abbr>
                    </>
              )}
                />

                <h3>Notifications</h3>
                <p>
                  Renewal Notifications will be sent 60 days before the renewal
                  date.
                </p>

                <Row className="mt20">
                  <Col md={4}>
                    <label>Notifications</label>
                  </Col>
                  <Col md={4}>
                    <Row>
                      <Col md={4}>Off</Col>
                      <Col className="text-center" md={4}>
                        <SwitchField name="renewal_notification" />
                      </Col>
                      <Col className="text-right" md={4}>
                        On
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <DateField
                  name="renewal_notification_date"
                  disabled={!values.renewal_notification}
                  label={(
                    <span>Policy Renewal Date</span>
                    )}
                />

              </div>

              <FieldArray name="affiliates">
                {({ remove, push }) => (
                  <div>
                    <h3>Affiliates</h3>

                    {values.affiliates.map(
                      (affiliateItem, index) => (
                        <Row>
                          <Col md={5}>
                            {affiliateItem.isAffiliateDeleted
                              ? (
                                <TextField
                                  value={affiliateItem.name}
                                  name={`affiliates.${index}.affiliate`}
                                  disabled
                                  readonly
                                />
                              )
                              : (
                                <SelectFieldV2
                                  name={`affiliates.${index}.affiliate`}
                                  placeholder={affiliates === null ? 'Wait ...' : 'Affiliate'}
                                  isMulti={false}
                                  options={affiliates && affiliates.map((item) => ({
                                    label: item.attributes.full_name,
                                    value: item.attributes.id,
                                  }))}
                                  required
                                />
                              )}
                          </Col>
                          <Col md={3}>
                            <SelectFieldV2
                              name={`affiliates.${index}.commission_type`}
                              placeholder="Type"
                              isMulti={false}
                              options={commissionType}
                              onChange={(value) => {
                                setFieldValue(`affiliates.${index}.commission_type`, value?.value);
                                if (value && value.value === 'direct') {
                                  setFieldValue(`affiliates.${index}.commission`, 10);
                                }
                                if (value && value.value === 'indirect') {
                                  setFieldValue(`affiliates.${index}.commission`, 5);
                                }
                              }}
                              required
                            />
                          </Col>
                          <Col md={3}>
                            <TextFieldWithAddon
                              name={`affiliates.${index}.commission`}
                              placeholder="Commission"
                              type="number"
                              addon="%"
                              min="0"
                              step="0.01"
                              pattern="d+(.d{1,2})?"
                              required
                            />
                          </Col>
                          <Col md={1}>
                            <a onClick={() => remove(index)}>
                              <img src={deleteIcon} alt="delete" />
                            </a>
                          </Col>
                        </Row>
                      ),
                    )}
                    <div>
                      <Button
                        onClick={() => push({
                          affiliate: '',
                          commission: 10,
                          commission_type: 'direct',
                        })}
                        bsStyle="primary"
                      >
                        Add Affiliate
                      </Button>

                    </div>

                  </div>
                )}
              </FieldArray>

              <div className="mt50 mb30">
                <Row>
                  <Col md={6}>
                    <CancelPopupButton
                      className="btn btn-primary btn-outline mr5 ml5 width-120"
                      title="Cancel"
                      onClick={() => onHide()}
                    />
                  </Col>
                  <Col md={6} className="text-right">
                    <SubmitButton
                      title={`${loader ? 'Updating ...' : 'Update'}`}
                      className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                        loader ? 'not-possible-click' : ''
                      }`}
                    />
                  </Col>
                </Row>
              </div>
            </FormikForm>
          );
        }}
      </Formik>
    </Modal>
  );
}
